import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Divider } from 'semantic-ui-react';
import _ from 'lodash';

import ConnectedAccount from '../facebook-connected-account';
import ConnectAccount from '../facebook-connect-account';
import FacebookMarketingCampaignLinker from '../../components/facebook-marketing-campaign-linker';

const FacebookAdsManager = ({
  account,
  name,
  campaignId,
  canLinkCampaigns,
}) => {
  const isAccountConnected = _.isObject(account) && _.isString(account.id);
  const id = _.get(account, 'id', null);
  const hasCampaignId = _.isString(campaignId);
  return (
    <Segment>
      <h3>Linked Facebook Ads Manager Account</h3>
      <Divider hidden fitted />
      {
        isAccountConnected ? <ConnectedAccount id={id} name={name} /> : <ConnectAccount />
      }

      { canLinkCampaigns && isAccountConnected && hasCampaignId && (
        <FacebookMarketingCampaignLinker
          campaignId={campaignId}
        />
      )}
    </Segment>
  );
};

FacebookAdsManager.propTypes = {
  account: PropTypes.shape({
    access_token: PropTypes.string.isRequired,
    business_name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    owner: PropTypes.string.isRequired,
  }),
  canLinkCampaigns: PropTypes.bool,
  name: PropTypes.string.isRequired,
  campaignId: PropTypes.string,
};

FacebookAdsManager.defaultProps = {
  account: null,
  campaignId: null,
  canLinkCampaigns: true,
};

export default FacebookAdsManager;



/** WEBPACK FOOTER **
 ** ./src/components/facebook-ads-manager/index.js
 **/